var React = require('react');

function MoreInfoInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.03613 0C0.838351 0 0.645012 0.0586494 0.480562 0.168531C0.316113 0.278412 0.187941 0.434591 0.112253 0.617317C0.0365656 0.800043 0.0167629 1.00111 0.0553482 1.19509C0.0939334 1.38907 0.189172 1.56725 0.329025 1.70711C0.468877 1.84696 0.64706 1.9422 0.841041 1.98079C1.03502 2.01937 1.23609 1.99957 1.41882 1.92388C1.60154 1.84819 1.75772 1.72002 1.8676 1.55557C1.97748 1.39112 2.03613 1.19778 2.03613 1C2.03613 0.734783 1.93078 0.48043 1.74324 0.292894C1.5557 0.105357 1.30135 0 1.03613 0Z","key":0}),React.createElement("rect",{"x":"0.0361328","y":"2.99976","width":"2","height":"6","rx":"1","key":1})]);
}

MoreInfoInline.defaultProps = {"width":"3","height":"9","viewBox":"0 0 3 9","fill":"none"};

module.exports = MoreInfoInline;

MoreInfoInline.default = MoreInfoInline;
